import { FC, Fragment } from 'react';
import { useGetSubscriptionOffers } from 'src/hooks';
import { SubscriptionOffer } from './SubscriptionOffer';

type Props = {
  store: string;
  cartValue: number;
};

export const GetSubscriptionOffers: FC<Props> = ({ store, cartValue }) => {
  const offers = useGetSubscriptionOffers(store, cartValue);

  return (
    <>
      {offers.map((offer, i) => (
        <Fragment key={`${i}-offer-${offer.name}`}>
          <SubscriptionOffer
            store={store}
            text={offer.text}
            link={offer.link}
            name={offer.name}
            imageSrc={offer.imageSrc}
          />
        </Fragment>
      ))}
    </>
  );
};
